<template>
  <v-app id="inspire">
    <v-content>
      <v-container class="fill-height" fluid>
        <v-row>
          <v-col class="mx-auto" cols="12" sm="8" md="6">
            <v-row>
              <v-col class="mx-auto py-0" cols="12">
                <v-alert dense outlined type="success">
                  <p class="mb-0">
                    You Successfully Registered, Check your mail.
                  </p>
                </v-alert>
              </v-col>
              <v-col class="mx-auto text-center" cols="12">
                <p>Or</p>
                <router-link to="/resend-verification-code">
                  Resend Verification Code
                </router-link>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {};
</script>
